import { Badge } from '@/components/ui/badge';

export type Status = 'published' | 'draft' | 'active' | 'inactive';

interface StatusBadgeProps {
  status: Status;
  className?: string;
}

const statusConfig = {
  published: {
    label: 'Published',
    variant: 'published' as const,
  },
  draft: {
    label: 'Draft',
    variant: 'draft' as const,
  },
  active: {
    label: 'Active',
    variant: 'active' as const,
  },
  inactive: {
    label: 'Inactive',
    variant: 'inactive' as const,
  },
};

/**
 * StatusBadge component for displaying status labels with consistent styling
 * @param status - The status type: "published", "draft", "active", or "inactive"
 * @param className - Optional additional CSS classes
 */
export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <Badge variant={config.variant} size="default" className={className}>
      {config.label}
    </Badge>
  );
}
